import {createAsyncThunk} from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axiosInstance';
import {environment} from '../../utils/environment/environment';
import {apiRequestErrorOccured, updateLoading} from '../slices/globalSlice';
import cookie from 'react-cookies';

const getExternalJobOfferInfo = createAsyncThunk(
  'vjo/getExternalJobOfferInfo',
  async (data, {dispatch}) => {
    dispatch(updateLoading(true));
    try {
      const baseURL =
        environment.hcServiceBasePostUrl + `/getExternalJobOfferInfo`;
      const response = await axiosInstance.post(baseURL, data);
      dispatch(updateLoading(false));
      cookie.save('isCpPorterDsPilot', response.data.response.cpPorterDsPilot);
      return response.data;
    } catch (error) {
      dispatch(apiRequestErrorOccured(error));
    }
  },
);

const finalizeJobOffer = createAsyncThunk(
  'vjo/finalizeJobOffer',
  async(data, {dispatch}) => {
    dispatch(updateLoading(true));
    try {
      const baseURL = environment.hcServiceBasePostUrl + `/finalizeJobOffer`;
      const response = await axiosInstance.post(baseURL, data);
      dispatch(updateLoading(false));
      return response.data;
    } catch (error) {
      dispatch(apiRequestErrorOccured(error));
    }
  },
);

export {getExternalJobOfferInfo, finalizeJobOffer};
